import React, {useEffect} from 'react';
import ChangeLogsHeader from '../components/changeLogsHeader/ChangeLogsHeader';
import ChangeLogsList from '../components/changeLogsList/ChangeLogsList';
import {observer} from 'mobx-react';
import useChangeLogsModel from '../common/hooks/useChangeLogsModel';
import {Label, Modal, Surface} from '@vidazoo/ui-kit';
import {useLocation} from 'react-router-dom';
import theme from './theme.module.scss';
import {renderValueSnapshot} from '../../../common/components/render-value-snapshot/renderValueSnapshot';

function ChangeLogs() {
    const model = useChangeLogsModel();
    const {search} = useLocation();
    useEffect(() => {
        const previousTitle = document.title;
        document.title = 'BI Dashboards';
        return () => {document.title = previousTitle;};
    }, []);
    useEffect(() => {
        model.setParamsFromSearch(search);
        model.getPlatformTags();
        model.getItems();
    }, [model, search]);

    return (
        <div className={theme.page}>
            <ChangeLogsHeader/>
            <ChangeLogsList/>
            <Modal external exitOnClickOutside onClose={() => model.setSelectedItem(null)} isOpen={!!model.selectedItem}>
                <Surface className={theme.modal} role="dialog" aria-label="Change log details">
                    <Label style={{cursor: 'text'}} uppercase={false}>
                        {renderValueSnapshot(model.selectedItem)}
                    </Label>
                </Surface>
            </Modal>
        </div>
    );
}

export default observer(ChangeLogs);
